<div class="karaoke-content rs_preserve">
    <div class="karaoke-content__title">
        <read-speaker-button [readId]="readIds"></read-speaker-button>
        <span class="title">Karaoketekst</span>
    </div>

    <div class="karaoke-content__container rs_preserve">
        <ng-content></ng-content>
    </div>
</div>
